import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import BrandedButton from '../../../Buttons/BrandedButton';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
/**
 * A wrapper around our DS `BrandedButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `BrandedButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */ const PopperBrandedToggleButton = (props)=>{
    const necessaryToggleProps = useDropdownToggleProps();
    return /*#__PURE__*/ React.createElement(BrandedButton, _object_spread({}, necessaryToggleProps, props));
};
PopperBrandedToggleButton.displayName = 'PopperBrandedToggleButton';
export default PopperBrandedToggleButton;
